import Big from "big.js";
export class AssetDepositConfig {
    constructor(reserveId, args) {
        this.reserveId = reserveId;
        this.min = (args === null || args === void 0 ? void 0 : args.min) ? new Big(args.min) : undefined;
        this.max = (args === null || args === void 0 ? void 0 : args.max) ? new Big(args.max) : undefined;
        this.remain = (args === null || args === void 0 ? void 0 : args.remain) ? new Big(args.remain) : undefined;
    }
    getReserveId() {
        return this.reserveId;
    }
    getMin() {
        return this.min;
    }
    getMax() {
        return this.max;
    }
    getRemain() {
        return this.remain;
    }
}
//# sourceMappingURL=AssetDepositConfig.js.map